/**
 * Path estável da foto do usuário autenticado (resolução por login no domínio do `apiUrl`).
 * Independente do `pessoa_id` numérico entre ambientes.
 */
export const PESSOA_FOTO_ME_API_PATH = '/api/pessoa/usuario/autenticado/foto/';

/** Normaliza qualquer foto_url da própria pessoa para o path autenticado. */
export function normalizePessoaFotoMeUrl(
  fotoUrl: string | null | undefined,
): string | null {
  if (!fotoUrl?.trim()) {
    return null;
  }
  return PESSOA_FOTO_ME_API_PATH;
}
